/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* ONTAP-specific restore options. Only applicable for FSx ONTAP volume restores.
*/
export class FSxRestoreDestinationOntapRestoreOptions {
  /**
  * Target SVM ID for ONTAP volume restore. If not provided, the volume will be restored to the original SVM. Use this to restore to a different SVM within the same file system. 
  */
  'storageVirtualMachineId'?: string;
  /**
  * Name for the restored volume. Must begin with a letter or underscore and contain only alphanumeric characters or underscores (max 203 characters). If not provided, the original volume name from the backup will be used. 
  */
  'volumeName'?: string;
  /**
  * Custom junction path (mount point) for the restored volume. Must begin with a forward slash. If not provided, the original junction path from the backup will be used. Use this to avoid conflicts with existing volumes on the target SVM. 
  */
  'junctionPath'?: string;
  /**
  * Size of the restored volume in bytes. Must be at least the size of the backup. If not provided, the original volume size from the backup will be used. 
  */
  'volumeSize'?: number;
  /**
  * Enable storage efficiency (deduplication and compression) on the restored volume. If not provided, the original setting from the backup will be used. 
  */
  'storageEfficiencyEnabled'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "storageVirtualMachineId",
      "baseName": "storageVirtualMachineId",
      "type": "string",
      "format": ""
    },
    {
      "name": "volumeName",
      "baseName": "volumeName",
      "type": "string",
      "format": ""
    },
    {
      "name": "junctionPath",
      "baseName": "junctionPath",
      "type": "string",
      "format": ""
    },
    {
      "name": "volumeSize",
      "baseName": "volumeSize",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "storageEfficiencyEnabled",
      "baseName": "storageEfficiencyEnabled",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return FSxRestoreDestinationOntapRestoreOptions.attributeTypeMap;
  }

  public constructor() {
  }
}

